<template>
  <div
    class="control-button d-flex justify-content-center"
    :class="[{ on: value }, { off: !value }]"
  >
    <a href="#" @click.prevent="clicked">
      <b-spinner label="Spinning" v-if="isWaiting"></b-spinner>
      <font-awesome-icon v-else icon="power-off" class="icon-power" />
    </a>
  </div>
</template>

<script>
export default {
  name: 'RoundButton',
  props: {
    value: Boolean,
    isWaiting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: false,
    };
  },
  methods: {
    clicked() {
      this.value_ = !this.value_;
      this.$emit('update', this.value_);
      this.$emit('click');
    },
  },
  mounted() {
    this.value_ = this.value;
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/settings.scss';

.control-button {
  a {
    display: block;
    background-color: #f7f7f7;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#f7f7f7), to(#e7e7e7));
    background-image: -webkit-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -moz-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -ms-linear-gradient(top, #f7f7f7, #e7e7e7);
    background-image: -o-linear-gradient(top, #f7f7f7, #e7e7e7);
    width: 50px;
    height: 50px;
    position: relative;
    text-align: center;
    border-radius: 50%;
    padding: 0.55rem;
    box-shadow: 0px 3px 8px #aaa, inset 0px 2px 3px #fff;
  }

  a:hover {
    text-decoration: none;
    box-shadow: 0px 3px 8px #3c3c3c, inset 0px 2px 3px #fff;
  }

  .icon-power {
    font-size: 2rem;
  }

  &.on a {
    color: $green;
  }

  &.off a {
    color: $red;
  }
  &.disabled a {
    color: $gray-800;
  }
}

</style>
